<template>
  <b-container class="communes">
    <h1 class="titre">Prochains passages</h1>
    <h2 class="selection_communes">Sélectionnez la commune de votre choix :</h2>
    <div class="div_loader" v-if="loading">
      <b-spinner class="loader" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="liste_communes row">
      <div v-for="idZone in listCommunesNames" :key="idZone" class="col-lg-3 col-md-4 col-12">
        <b-btn :to="{name: 'Arrets', params: {idZone: idZone}}" class="commune">
          <span class="nom_commune">{{ idZone }}</span>
        </b-btn>
      </div>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'Communes',
    data () {
      return {
        listCommunesNames: null,
        loading: false
      }
    },
    mounted () {
      this.loading = true
      this.axios.get('/listStops')
        .then((succes) => {
          this.listCommunesNames = succes.data
          this.loading = false
        }, (error) => {
          console.error('ERREUR', error.body)
        })
    }
  }
</script>

<style lang="scss">
@import "src/sass/app";

.communes {
  text-align: center;
  margin-top: 3rem;

  .titre {
    color: $secondcolor;
    font-family: $titlefont;
    font-size: 40px;
    margin-bottom: 2rem;
  }

  .selection_communes {
    color: $secondcolor;
    font-family: $textfont;
    font-size: 35px;
  }

  .div_loader {
    display: flex;
    margin: 4rem 0;
    @include media-breakpoint-up(sm) {
      height: 0;
    }

    .loader {
      margin: auto;
      color: $secondcolor;
      width: 6rem;
      height: 6rem;
    }
  }

  .liste_communes {
    justify-content: center;
    margin-top: 2rem;
    display: flex;
    .commune {
      height: 100px;
      border: 2px solid $secondcolor;
      background-color: white;
      border-radius: 10px;
      color: $secondcolor;
      font-family: $titlefont;
      font-size: 20px;
      margin: 15px 0;
      padding: 1rem;
      text-decoration: none;
      display: flex;
      .nom_commune {
        margin: auto;
      }
    }
    .commune:hover {
      background-color: $secondcolor;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Communes.vue